module.exports = __webpack_public_path__ + "ath_game_web/img/9.3.877490e4.png";